import { makeAutoObservable, runInAction } from "mobx"
import { AssetSectionSettings } from "../asset-section-editor-settings"
import { EditorSteps } from "../editor-utils/editor-types"
import {
    EditingAssetSectionWindow,
    LinerDrawingReference,
    PutLinerLocation,
    PutLinerRegion,
    WearReferencePlane,
} from "features/organizations/asset-sections/models/asset-section-models"

export class AssetSectionEditorStore {
    constructor() {
        makeAutoObservable(this)
    }

    currentStep: EditorSteps = EditorSteps.SVGSettings
    showEditBox: boolean = false
    selectedLiners: PutLinerLocation[] = []
    selectedWearReferencePlane: WearReferencePlane[] = []
    selectedholes: PutLinerRegion[] = []
    selectedLinersDrawingRef: LinerDrawingReference[] = []
    assetSectionImage: string | null = null
    editBoxLinerRegionNameInputValue: string = ""
    selectedPathId: string | null = null
    editBoxInputValue: string | number = ""
    firstLinerName: string = ""
    firstDrawingReferenceName: string = ""
    surroundingHoleLiner: string = ""
    assetSectionSettings: AssetSectionSettings = {
        sensorNotificationArea: 4,
        radiusHint: 0.2,
        lineWeight: 1,
    }
    editAssetSectionWindow: EditingAssetSectionWindow = {
        id: "",
        customerId: "",
        siteId: "",
        assetId: "",
        name: "",
        description: "",
        radiusHint: 0.2,
        sensorNotificationArea: 4,
        lineWeight: 1,
        assetSectionSvg: null,
        assetSectionPdf: null,
    }

    resetAll = () => {
        runInAction(() => {
            this.currentStep = EditorSteps.SVGSettings
            this.showEditBox = false
            this.selectedLiners = []
            this.selectedWearReferencePlane = []
            this.selectedholes = []
            this.selectedLinersDrawingRef = []
            this.assetSectionImage = null
            this.editBoxLinerRegionNameInputValue = ""
            this.selectedPathId = null
            this.editBoxInputValue = ""
            this.firstLinerName = ""
            this.firstDrawingReferenceName = ""
            this.surroundingHoleLiner = ""
            this.assetSectionSettings = {
                sensorNotificationArea: 4,
                radiusHint: 0.2,
                lineWeight: 1,
            }
            this.editAssetSectionWindow = {
                id: "",
                customerId: "",
                siteId: "",
                assetId: "",
                name: "",
                description: "",
                radiusHint: 0.2,
                sensorNotificationArea: 4,
                lineWeight: 1,
                assetSectionSvg: null,
                assetSectionPdf: null,
            }
        })
    }

    resetUIStates = () => {
        this.setSelectedPathId(null)
        this.restEditBox()
    }

    restEditBox = () => {
        this.setShowEditBox(false)
        this.setEditBoxInputValue("")
        this.setEditBoxLinerRegionNameInputValue("")
    }

    resetCurrentStep = () => {
        runInAction(() => {
            this.currentStep = 0
        })
    }

    nextCurrentStep = () => {
        runInAction(() => {
            this.currentStep = this.currentStep + 1
        })
    }

    backCurrentStep = () => {
        runInAction(() => {
            this.currentStep = this.currentStep - 1
        })
    }

    setShowEditBox = (value: boolean) => {
        runInAction(() => {
            this.showEditBox = value
        })
    }

    setSelectedLiners = (array: PutLinerLocation[]) => {
        runInAction(() => {
            this.selectedLiners = array
        })
    }

    setSelectedWearReferencePlane = (array: WearReferencePlane[]) => {
        runInAction(() => {
            this.selectedWearReferencePlane = array
        })
    }

    setSelectedHoles = (array: PutLinerRegion[]) => {
        runInAction(() => {
            this.selectedholes = array
        })
    }

    setSelectedLinersDrawingRef = (array: LinerDrawingReference[]) => {
        runInAction(() => {
            this.selectedLinersDrawingRef = array
        })
    }

    setAssetSectionImage = (image: string | null) => {
        runInAction(() => {
            this.assetSectionImage = image
        })
    }

    setEditBoxLinerRegionNameInputValue = (value: string) => {
        runInAction(() => {
            this.editBoxLinerRegionNameInputValue = value
        })
    }

    setSelectedPathId = (value: string | null) => {
        runInAction(() => {
            this.selectedPathId = value
        })
    }

    setEditBoxInputValue = (value: string | number) => {
        runInAction(() => {
            this.editBoxInputValue = value
        })
    }

    setFirstLinerName = (value: string) => {
        runInAction(() => {
            this.firstLinerName = value
        })
    }

    setFirstDrawingReferenceName = (value: string) => {
        runInAction(() => {
            this.firstDrawingReferenceName = value
        })
    }

    setSurroundingHoleLiner = (value: string) => {
        runInAction(() => {
            this.surroundingHoleLiner = value
        })
    }

    setAssetSectionSettings = (value: AssetSectionSettings) => {
        runInAction(() => {
            this.assetSectionSettings = value
        })
    }

    setEditAssetSectionWindow = (value: EditingAssetSectionWindow) => {
        runInAction(() => {
            this.editAssetSectionWindow = value
        })
    }
}

const assetSectionEditorStore = new AssetSectionEditorStore()
export default assetSectionEditorStore
